import { Button, Result, Typography } from "antd";

/**
 * Trạng thái lỗi (UIUX §7, BA-06 §5): nêu lỗi gì, ở đâu, cách sửa; cung cấp
 * hành động thử lại. `requestId` chỉ hiển thị ở trạng thái lỗi, dưới nhãn
 * "Mã hỗ trợ" (guardrail ERROR_SUPPORT) — không lộ mã lỗi kỹ thuật/trace.
 */
export function ErrorState({ title, description, requestId, onRetry }: {
  readonly title: string;
  readonly description?: string | undefined;
  readonly requestId?: string | undefined;
  readonly onRetry?: (() => void) | undefined;
}) {
  return (
    <Result
      status="error"
      title={title}
      subTitle={description}
      extra={
        <>
          {onRetry ? (
            <Button type="primary" onClick={onRetry}>
              Thử lại
            </Button>
          ) : null}
          {requestId ? (
            <Typography.Paragraph type="secondary" style={{ marginTop: "var(--ncc-spacing-md)", marginBottom: 0 }}>
              Mã hỗ trợ: {requestId}
            </Typography.Paragraph>
          ) : null}
        </>
      }
    />
  );
}
